
export function jsonToSubscope9(standort_tid: number, tid: number, name: string, jahr: number, besucher: number, results: any, datenherkunft: number) {
    const rows: any = [];
    const entfernungen = results.entfernungen;
    const uebernachtungen = results.uebernachtungen;
    const besucher_erfasst = results.personenzahl;
    const faktor_hochrechnung = (besucher / besucher_erfasst) || 1;

    if (entfernungen) {
        Object.keys(entfernungen).forEach((k: string, i: number) => {
            const vals =  entfernungen[k];
            // console.log('S9 Vals', results, besucher, besucher_erfasst, faktor_hochrechnung, vals);
            const item = getBaseItem(`${tid}_e${i + 1}`);
            item.standort_tid = standort_tid;
            item.standort_tid_orig = standort_tid;
            item.jahr = jahr;
            item.transportmittel = k;
            const avg_dist = vals.km * faktor_hochrechnung;
            item.entfernung = avg_dist;
            item.personen = 1;
            item.name_veranstaltung = name;
            item.datenherkunft = datenherkunft;
            item.bewertung_emissionsfaktor = 1;
            rows.push(item);
        });
    }
    if (uebernachtungen) {
        Object.keys(uebernachtungen).forEach((k: string, i: number) => {
            const vals =  uebernachtungen[k];
            const item = { ...getBaseItem(`${tid}_u${i + 1}`) };
            item.standort_tid = standort_tid;
            item.standort_tid_orig = standort_tid;
            item.jahr = jahr;
            item.entfernung = 0;
            item.personen = 1;
            item.uebernachtungen = 'Ja';
            item.uebernachtungen_orig = 1;
            item.uebernachtungen_anzahl = vals.anzahl * faktor_hochrechnung;
            item.unterkunft = k;
            item.modus = 'none';
            item.name_veranstaltung = name;
            item.datenherkunft = datenherkunft;
            item.bewertung_emissionsfaktor = 1;
            rows.push(item);
        });
    }
    return rows;
}

function getBaseItem(id: string): any {
    return {
        // tid: -999,
        tid: `kampagne_${id}`,
        standort_tid: 0,
        parent_tid: 0,
        jahr: 0,
        lieferant_tid: 0,
        teilstrecken: 'Nein',
        transportmittel: '',
        entfernung: 200,
        menge: 0,
        bemerkung: '',
        mandant: '',
        art: 'mobilitaet',
        modus: 'distance_based',
        kosten: 0,
        energietraeger_tid: 0,
        verbrauch: 0,
        personen: 0,
        uebernachtungen: 'Nein',
        uebernachtungen_anzahl: 2,
        unterkunft: 'hotel_0',
        hin_rueck: 'Nein',
        anhang: '',
        standort_tid_orig: 0,
        teilstrecken_orig: 2,
        hin_rueck_orig: 2,
        uebernachtungen_orig: 2
    };
}
